import usePagination from "hooks/usePagination";
import { useState } from "react";
import { queryKeys } from "api/master";
import { useQuery } from "@tanstack/react-query";
import { MEMBER_ATTENDED_TAB_ACTIVE_KEY } from "common/common";
import { Table } from "antd";
import { cn } from "libs/classnames";

const LotteryDrawHistory = ({ memberId, tabActiveKey }) => {
	const { pagination, setPaginationTotal, setPaginationPage } = usePagination({
		initialSortKey: "drawId",
		initialPerPage: 10,
	});
	const [lotteryDrawHistories, setLotteryDrawHistories] = useState([]);

	useQuery({
		...queryKeys.members.listOfLotteryDrawHistories({
			pp: pagination.perPage,
			p: pagination.page,
			sort: pagination.sort,
			sortKey: pagination.sortKey,
			memberId,
		}),
		onSuccess: async (response) => {
			setPaginationTotal(response.count || 0);
			setLotteryDrawHistories(response.rows);
		},
		enabled:
			tabActiveKey === MEMBER_ATTENDED_TAB_ACTIVE_KEY.LOTTERY && !!memberId,
	});

	return (
		<Table
			bordered
			size="small"
			rowKey="drawId"
			className={cn(
				"[&_.ant-table-wrapper]:max-h-[60vh]",
				"[&_.ant-table-container]:max-h-[50vh]",
				"[&_.ant-table-container]:overflow-y-scroll",
				"[&_.ant-table-content]:min-w-[560px]",
			)}
			dataSource={lotteryDrawHistories}
			columns={[
				{
					title: "くじ引き名",
					key: "lotteryName",
					dataIndex: "lotteryName",
				},
				{
					title: "賞品名",
					key: "prizeName",
					dataIndex: "prizeName",
				},
				{
					title: "クーポン",
					key: "couponName",
					dataIndex: "couponName",
					render: (value) => value || "－",
				},
			]}
			scroll={{
				x: "max-content",
			}}
			pagination={{
				current: pagination.page,
				total: pagination.total,
				onChange: setPaginationPage,
				pageSize: pagination.perPage,
			}}
		/>
	);
};

export default LotteryDrawHistory;
